export enum Lang {
  RU = 'ru',
  ES = 'es',
  ENG = 'en',
  DE = 'de',
}
